import { useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import ButtonDropdown from '../../../../components/core/ButtonDropdown/ButtonDropdown';
import { setFormMetaInfo } from '../../../../components/FormBuilderLibrary/slice';

const ActionButton = ({ clickedRow }) => {
	const dispatch = useDispatch();
	const [searchParams, setSearchParams] = useSearchParams();

	const addFormButton = {
		title: 'ADD FORM',
		id: 198567,
		tipPlacement: 'left',
		variant: 'outlined',
		marginBottom: '0px',
		popperPlacement: 'bottom-end',
		tipTitle: 'Not available.',
		options: [
			{
				disabled: false,
				title:
					clickedRow?.type === 'Submission Stage'
						? 'Select Application Form Template'
						: 'Select Review Form Template',
				onClick: () => {
					dispatch(
						setFormMetaInfo({
							stage_title: clickedRow?.title
						})
					);
					setSearchParams({
						...searchParams,
						templateSelection:
							clickedRow?.type === 'Submission Stage' ? 'application-form' : 'review-form',
						stageId: clickedRow?.stage_id
					});
				}
			}
		]
	};

	return <ButtonDropdown data={addFormButton} noDropShadow />;
};

export default ActionButton;
